export var EventsStreamEventEventType;
(function (EventsStreamEventEventType) {
    EventsStreamEventEventType["Friction"] = "friction";
    EventsStreamEventEventType["Data"] = "data";
})(EventsStreamEventEventType || (EventsStreamEventEventType = {}));
//# sourceMappingURL=event-stream.enums.js.map